<template>
  <div>
    <div class="box">
      <p class="return" @click="back">返回首页</p>
      <span class="line">|</span>
      <p class="contract">系统设置</p>
      <span class="lines">></span>
      <p class="contract back" @click="$router.go(-1)">合同公司</p>
      <span class="lines">></span>
      <p class="contract">公司印章</p>
    </div>
    <div class="contentTitle">
      <div class="mainTitle" @click="seal(75)">公司印章</div>
      <div class="btns">
        <button class="subbtn btn" @click="onedit">添加公司印章</button>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="seals"
        style="width: 100%"
        :header-cell-style="{ background: '#f8fafb', color: '#303140' }"
      >
        <el-table-column
          label="印章名称"
          prop="sealName"
          min-width="20"
          align="left"
        ></el-table-column>
        <el-table-column label="授权状态" prop="authzState" min-width="25%">
          <template slot-scope="scope">
            <span v-if="scope.row.expireTime == 0 || scope.row.expireTime == null && !scope.row.willDateTrue  " class="span_bgc1"
              >未授权</span
            >
            <span v-if="scope.row.expireTime  && !scope.row.willDateTrue" class="span_bgc4">已授权</span>

            <span
                v-if="scope.row.expireTime  && scope.row.willDateTrue "
                class="span_bgc2"
                >授权即将到期</span
              >
          
            <span
              class="hove"
              v-if="scope.row.expireTime == 0 || scope.row.expireTime == null ||  scope.row.willDateTrue"
              @click="goauth(scope.row.sealId)"
              >去授权</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="印章授权生效时间"
          prop="effectiveTime"
          min-width="20"
          align="left"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.effectiveTime == 0">-</span>
            <span v-else>{{ scope.row.effectiveTime }}</span>

          </template></el-table-column
        >
        <el-table-column
          label="印章授权过期时间"
          prop="expireTime"
          min-width="20"
          align="left"
        >
          <template slot-scope="scope"> <span v-if="scope.row.expireTime == 0">-</span>
            <span v-else>{{ scope.row.expireTime }}</span>
    </template>
        </el-table-column>
        <el-table-column
          label="创建日期"
          prop="sealCreateTime"
          min-width="20"
          align="center"
        >
          <template slot-scope="scope">{{
            scope.row.sealCreateTime | time
          }}</template>
        </el-table-column>
        <el-table-column label="操作" min-width="10" align="center">
          <template slot-scope="scope">
            <el-dropdown placement="bottom" size="small">
              <span class="el-dropdown-link menu">
                <span></span>
                <i>操作</i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  @click.native="preview(scope.row.sealImageDownloadUrl)"
                  >预览</el-dropdown-item
                >
                <el-dropdown-item
                  :disabled="scope.row.defaultSealFlag"
                  @click.native="deleteSeal(scope.row.sealId)"
                  >删除</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <SsgMessagebox
      height="auto"
      titles=""
      v-if="messageshow"
      :shutshow="false"
      subname="取消"
      @shut="shut"
      @sub="shut"
    >
      <div class="form">
        <img style="scale: 0.8" :src="imgurl" alt="" />
      </div>
    </SsgMessagebox>
  </div>
</template>

<script>
export default {
  data() {
    return {
      seals: [],
      imgurl: "",
      messageshow: false,
      nowdate:''
    };
  },
  created() {
    const today = new Date();
    this.nowdate =  today.getTime()
    this.getSealList();
  },
  methods: {
    goauth(id) {
      this.$axios
        .get(
          "/companyContract/seal/auth?id=" +
            this.$route.query.company_id +
            "&sealId=" +
            id
        )
        .then((res) => {
          window.open(res.data.data);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    shut() {
      this.messageshow = false;
    },
    back() {
      this.$router.push({ path: "/main" });
    },
    onedit() {
      this.$router.push({
        path: "seal/create",
        query: { cid: this.$route.query.company_id, id: this.$route.query.id },
      });
    },
    getSealList() {
      const params = { orgId: this.$route.query.id };
      this.$axios
        .get("/companyContract/seal/list", { params })
        .then((res) => {
          if (res.data.status == 1) {
            this.seals = res.data.data;
            for (let i = 0; i < this.seals.length; i++) {
              this.seals[i].willDateTrue = false
              if(this.seals[i].expireTime){
               
                let date = new Date(this.seals[i].expireTime);
                let givenDate = date.getTime();
                let dateCha =  givenDate -this.nowdate ;
                var days = dateCha / (1000 * 60 * 60 * 24);
              if(days <= 15){
                this.seals[i].willDateTrue = true
              }
              
              }
             
              
              
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    deleteSeal(id) {
      this.$confirm("您确定要删除印章吗?删除后无法恢复", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .delete("/companyContract/seal/delete/"+this.$route.query.id+'/' + id)
          .then((res) => {
            if (res.data.status == 1) {
              this.$message.success(res.data.message);
              this.getSealList();
            }
          })
          .catch((err) => {
            console.error(err);
          });
      });
    },

    preview(url) {
      this.messageshow = true;
      this.imgurl = url;
    },
  },
};
</script>

<style src="../../../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../../../assets/css/common/table.less" scoped lang="less"></style>
<style scoped lang="less">
.box {
  display: flex;
  margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .back:hover {
    color: #6669e3;
    cursor: pointer;
  }

  .contract {
    margin-right: 20px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}
.tab_nav {
  border-bottom: none;
}
.cz {
  line-height: 23px;
  background-image: url(../../../../assets/img/delete.png);
  background-size: 18px;
  background-position: left center;
  background-repeat: no-repeat;
  padding-left: 20px;
  cursor: pointer;
}
.el-table__row:hover {
  .cz {
    background-image: url(../../../../assets/img/delete.png);
  }
}
.box {
  display: flex;
  margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}
.mainTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(48, 49, 64, 1);
  margin: 23px 0 33px 0;
}
.tab_nav[data-v-19dec5c4] {
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #f2f5f8;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.contentTitle {
  display: flex;
  justify-content: space-between;
  .btns {
    margin-top: 20px;
  }
}
.span_bgc1 {
  padding: 3px 5px;
  background-color: #ff6752;
  color: #fff;
  border-radius: 4px;
}
.span_bgc2 {
  padding: 3px 5px;
  background-color: #f6d703;
  color: #fff;
  border-radius: 4px;
}
.span_bgc4 {
  padding: 3px 5px;
  background-color: #3bc798;
  color: #fff;
  border-radius: 4px;
}
.hove {
  color: #8285ff;
  cursor: pointer;
  margin-left: 10px;
}
</style>
